import gql from 'graphql-tag'
import { GQL_PROJECT_ASSISTANT_DEFAULT_FIELDS } from '@/components/projects/graphql/graphql.const.ts'

export const GetChatListPreviewQuery = gql`
  query FindChatsList ($input: FindChatsInput!) {
    chatList: getChatsListPreview (input: $input) {
      pageSize
      page
      total
      data {
        chatId
        chatKey
        chatIndex
        isCustomerOnline
        isAiControlIntercepted
        contactEmails
        contactPhones
        isFresh
        lastMessage {
          content
          createdAt
          event
        }
      }
    }
  }
`

export const GetChatMessagesAndInfo = gql`
  query GetChatMessagesAndInfo ($projectId: Uint!, $chatIndex: Uint!) {
    messages: getChatMessages(projectId: $projectId, chatIndex: $chatIndex) {
      eventId
      event
      content
      createdAt
    }

    trackingInfo: getChatTrackingInfo (projectId: $projectId, chatIndex: $chatIndex) {
      referer
      screenResolution
      clientIp
      platform
      browserLanguage
      location {
        countryCode
        country
        city
        region
      }
    }
  }
`